import { API_URL } from '@/config';
import { privateApi } from './api';
import { useMutation } from '@tanstack/react-query';

export type ExportType = 'zip' | 'timelapse';

export interface PrepareExportInput {
    projectId: string;
    sampleIds: string[];
    type: ExportType;
    from: string; // ISO
    to: string; // ISO
    name: string;
    period?: string;
}

// One token for the zip, which holds every sample; one per sample for the
// timelapses. Samples with nothing in the range are left out.
const prepareExport = async (input: PrepareExportInput) => {
    const { projectId, ...body } = input;
    const res = await privateApi.post<{ tokens: string[] }>(
        `/project/${projectId}/export/prepare`,
        body,
    );
    return res.data;
};

export const buildExportDownloadUrl = (projectId: string, token: string) =>
    `${API_URL}/project/${projectId}/export/download?token=${encodeURIComponent(
        token,
    )}`;

export const usePrepareExport = () =>
    useMutation({ mutationFn: prepareExport });

// Trigger a file download via a hidden iframe rather than navigating the tab,
// so that a server-side error (expired token, empty range) never replaces the
// SPA with a JSON error page. Once the browser starts the download it continues
// independently; we remove the iframe after a generous delay.
export const triggerBrowserDownload = (url: string) => {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    document.body.appendChild(iframe);
    setTimeout(() => iframe.remove(), 10 * 60 * 1000);
};
